import { createContext, useContext } from 'react';

export interface IDoctorConfirmationForm {
  firstName: string;
  email: string;
  disclaimer?: boolean;
  alarmDisclaimer?: boolean;
}

type DoctorConfirmationContextType = IDoctorConfirmationForm & {
  /** Amount to charge for confirmation */
  chargeAmount: number;
  /* For stripe integration */
  customerId?: string;
  setCustomerId: (customerId: string) => void;

  currentQuestionIndex: number;
  setCurrentQuestionIndex: (questionIndex: number) => void;
  isError: boolean;
  setIsError: (isError: boolean) => void;
  errorMessage?: string;
  setErrorMessage: (errorMessage: string) => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
};

export const DoctorConfirmationContext = createContext<DoctorConfirmationContextType>({
  chargeAmount: 1,
  currentQuestionIndex: 0,
  email: '',
  firstName: '',
  isError: false,
  isLoading: false,
  setCurrentQuestionIndex: () => {},
  setCustomerId: () => {},
  setErrorMessage: () => {},
  setIsError: () => {},
  setIsLoading: () => {},
});

export default function useDoctorConfirmationContext() {
  return useContext(DoctorConfirmationContext);
}
